import { render, staticRenderFns } from "./FormInputPassword.vue?vue&type=template&id=6045734e&scoped=true&"
import script from "./FormInputPassword.vue?vue&type=script&lang=js&"
export * from "./FormInputPassword.vue?vue&type=script&lang=js&"
import style0 from "./FormInputPassword.vue?vue&type=style&index=0&id=6045734e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6045734e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormLabelPassword: require('/workspace/components/Form/FormLabelPassword.vue').default})
